import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManifestoEmbarquePainelService {
  constructor(private http: HttpClient) { }

  getMEDetalhes(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto-Embarque/Detalhe?ManifestoId=${req.manifestoId}&isDevolucao=${req.isDevolucao}&FiltroDataRecepcao=${req.dataRecepcao}&FiltroRessalva=${req.ressalva}
          ${req.codigoBarras ? `&codigoBarras=${req.codigoBarras}` : ''}
          ${req.paginaAtual ? `&PaginaAtual=${(req.paginaAtual || 0) + 1}` : '&PaginaAtual=1'}
          ${req.itensPorPagina ? `&ItensPorPagina=${req.itensPorPagina}` : '&PaginaAtual=10'}`,
        { observe: 'response' }
      );
  };

  getMEDetalheContador(req: any): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(
        `Manifesto-Embarque/Detalhe/Contador?${req.manifestoEmbarqueId ? `manifestoEmbarqueId=${req.manifestoEmbarqueId}` : ''}
        ${req.manifestoId ? `&manifestoId=${req.manifestoId}` : ''}
        ${req.isDevolucao ? `&isDevolucao=${req.isDevolucao}` : ''}`
      );
  }

  getAll(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto-Embarque/Painel? ${req.manifestoEmbarqueId ? `&manifestoEmbarqueId=${req.manifestoEmbarqueId}` : ''}
        ${req.dataFinal ? `&dataFinal=${req.dataFinal}` : ''}
        ${req.codigoBarras ? `&codigoBarras=${req.codigoBarras}` : ''}
        ${req.tipoSituacaoManifestoEmbarqueId ? `&tipoSituacaoManifestoEmbarqueId=${req.tipoSituacaoManifestoEmbarqueId}` : ''}
        ${req.dataInicial ? `&dataInicial=${req.dataInicial}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getManifestoEmbarqueDetalhesDevolucao(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto-Embarque/Detalhe/Devolucao? ${req.manifestoEmbarqueId ? `&manifestoEmbarqueId=${req.manifestoEmbarqueId}` : ''}
        ${req.agenteId ? `&agenteId=${req.agenteId}` : ''}
        ${req.codigoBarras ? `&codigoBarras=${req.codigoBarras}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
        { observe: 'response' }
      );
  }

  getManifestoEmbarqueDetalhesTransporte(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto-Embarque/Detalhe/Transporte? ${req.manifestoEmbarqueId ? `&manifestoEmbarqueId=${req.manifestoEmbarqueId}` : ''}
        ${req.agenteId ? `&agenteId=${req.agenteId}` : ''}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : ''}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}
        ${req.codigoBarras ? `&codigoBarras=${req.codigoBarras}` : ''}`,
        { observe: 'response' }
      );
  }

  getTiposRessalva(): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto-Embarque/Ressalva/Tipo`,
        { observe: 'response' }
      );
  }

  getMEContadoresPainel(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto-Embarque/Painel-Cards?${req.manifestoEmbarqueId ? `&manifestoEmbarqueId=${req.manifestoEmbarqueId}` : ''}
        ${req.dataFinal ? `&dataFinal=${req.dataFinal}` : ''}
        ${req.dataInicial ? `&dataInicial=${req.dataInicial}` : ''}
        ${req.tipoSituacaoVisualizacaoId ? `&tipoSituacaoVisualizacaoId=${req.tipoSituacaoVisualizacaoId}` : ''}
        ${req.codigoBarras ? `&codigoBarras=${req.codigoBarras}` : ''}`,
        { observe: 'response' }
      );
  }

  getMEParametro(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `Manifesto-Embarque/Parametro/?chave=${req.chave}&agenteId=${req.agenteId}`,
        { observe: 'response' }
      );
  }

  createRessalva(objectRequest: any): Observable<any> {
    return this.http.post(
      `Manifesto-Embarque/Ressalva`,
      objectRequest,
      { observe: 'response' }
    );
  }

  baixarME(objectRequest: any): Observable<any> {
    return this.http.post(
      `Manifesto-Embarque/Baixa`,
      objectRequest,
      { observe: 'response' }
    );
  }


  salvarJustificativaAprovacao(objectRequest: any): Observable<any> {
    console.log('--objectRequest---->', JSON.stringify(objectRequest))
    return this.http.post(
      `Manifesto-Embarque/SalvaSolicitacao`,
      objectRequest,
      { observe: 'response' }
    );
  }
}
